import React, { useEffect, useState } from "react";
import { BASE_URL, BLACK, PRIMARY, WHITE } from "../../../appConstants";
import { Button, Input, Snackbar, Switch, Tooltip } from "@mui/joy";
import Icon from "../../../svg/Ads Dashboard Development/Small/elements.svg";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import DateRangeComponent from "../../commonComponents/DateRangeComponent/DateRangeComponent";
import DateIcon from "../../../svg/Ads Dashboard Development/DateIcon/elements.svg";
import DragAndDropIcon from "../../../svg/Ads Dashboard Development/Drag_and_Drop_Icon/elements.svg";
import ErrorIcon from "../../../svg/Ads Dashboard Development/ErrorIcon/elements.svg";
import ErrorCrossIcon from "../../../svg/Ads Dashboard Development/ErrorCrossIcon/elements.svg";
import MultiSelect from "../../commonComponents/MultiSelect";
import { useSelector } from "react-redux";
import axios from "axios";
import appError from "../../../appError";
import { ColDef } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import {
  // formatCurrentDate,
  formatDate,
  formatDatefunc,
  formatMonthYear,
  formatToDDMMYYYY,
  formatWeekInput,
  getMonthName,
  getMonthsInRange,
  getYearsFromGivenRange,
  getYearsFromRange,
} from "../../../appFunctions";

type DynamicObject = {
  [key: string]: any;
};
type DateRange = {
  start: Date;
  end: Date;
};
type DataProps = {
  [key: string]: any;
};
type MonthProps = {
  id: string;
  label: string;
};
type RangeProps = {
  min_date: Date;
  max_date: Date;
};
type WeeksProps = {
  id: string;
  label: string;
};
type WeekProps = [number, number];
type FilterProps = {
  filter_type: string;
  type: string;
  month: number[];
  year: number[];
  week: WeekProps[];
  start_date: string;
  end_date: string;
};

interface CustomTooltipContentProps {
  min_date: Date;
  max_date: Date;
}
type Matrice = {
  id: number;
  matrice: string;
  toggle: boolean;
  position: number;
};
const Summary: React.FC = () => {
  const getMatricesData = localStorage.getItem(
    "AdsOverviewSummaryTableSelectedMatrices"
  );
  const [matricesData, setMatricesData] = useState<Matrice[]>(
    getMatricesData
      ? JSON.parse(getMatricesData)
      : [
          { id: 1, matrice: "Impressions", toggle: true, position: 0 },
          { id: 2, matrice: "Clicks", toggle: true, position: 1 },
          { id: 3, matrice: "Spend", toggle: true, position: 2 },
          { id: 4, matrice: "Sales", toggle: true, position: 3 },
          { id: 5, matrice: "Units", toggle: true, position: 4 },
        ]
  );
  const location = useLocation();
  const navigate = useNavigate();
  const full_name = localStorage.getItem("full_name");
  const words: string[] = full_name ? full_name.split(" ") : [" "];
  const [datename, setdatename] = useState<string>("");
  const [DateRange, setDateRange] = useState<DateRange>({
    start: new Date("Fri Nov 01 2024 00:00:00 GMT+0530 (India Standard Time)"),
    end: new Date("Fri Nov 30 2024 00:00:00 GMT+0530 (India Standard Time)"),
  });
  const [BrandRange, setBrandRange] = useState<string | null>(
    localStorage.getItem("BrandRange")
  );
  const [range, setRange] = useState<RangeProps>({
    min_date: new Date(
      BrandRange && JSON.parse(BrandRange).min_date.split("T")[0]
    ),
    max_date: new Date(
      BrandRange && JSON.parse(BrandRange).max_date.split("T")[0]
    ),
  });

  const getDateMinusDays = (days: number): string => {
    // Create a new Date instance for today
    const today = new Date();

    // Subtract the specified number of days
    today.setDate(today.getDate() - days);

    // Format the date as a string (e.g., YYYY-MM-DD)
    const formattedDate = today.toISOString().split("T")[0];
    return formattedDate;
  };
  const [filter, setFilter] = useState<FilterProps>({
    filter_type: "TIMELINE",
    type: "DAILY",
    month: [new Date().getMonth() + 1],
    year: [2024],
    week: [[1, 7]],
    start_date: getDateMinusDays(7),
    end_date: formatDate(new Date()),
  });
  const inputRef = React.useRef<HTMLInputElement>(null);
  const dropdownRef = React.useRef<HTMLDivElement>(null);
  const [rowsToggle, setRowsToggle] = useState<boolean>(false);
  const [rowsdata, setRowsdata] = useState<string[]>([]);
  const [selectedMatrices, setSelectedMatrices] = useState<Set<string>>(
    new Set(["Impressions", "Clicks", "Spend", "Sales", "Units"])
  );
  const [data, setData] = useState<DataProps[]>([]);
  const [filterdata, setfilterData] = useState<DataProps[]>([]);
  const [months, setMonths] = useState<MonthProps[]>(
    getMonthsInRange(range?.min_date, range?.max_date)
  );
  const [selectedMonths, setSelectedMonths] = useState<Set<string>>(
    new Set([String(filter?.month[0])])
  );
  const [weeks, setWeeks] = useState<WeeksProps[]>([
    { id: "1", label: "Week 1" },
    { id: "2", label: "Week 2" },
    { id: "3", label: "Week 3" },
    { id: "4", label: "Week 4" },
    { id: "5", label: "Week 5" },
  ]);
  const [selectedWeeks, setSelectedWeeks] = useState<Set<string>>(
    new Set(["1"])
  );
  const [selweeks, setSelweeks] = useState<WeekProps[]>([]);
  const [startDate, setStartDate] = useState<number>();
  const [endDate, setEndDate] = useState<number>();
  const { brand_id } = useSelector((state: any) => state.appData);
  const [columnDefs, setColumnDefs] = useState<ColDef<DataProps>[]>([]);
  const [apiFilterPeriodtype, setApiFilterPeriodType] = useState<string>("");
  const [errorToggle, setErrorToggle] = useState<boolean>(false);
  const apply = (data: any) => {
    setDateRange((prev) => ({
      ...prev,
      ["start"]: new Date(data?.startDate),
      ["end"]: new Date(data?.endDate),
    }));
    setFilter((prev) => ({
      ...prev,
      ["start_date"]: `${data?.startDate.getFullYear()}-${String(
        data?.startDate.getMonth() + 1
      ).padStart(2, "0")}-${String(data?.startDate.getDate()).padStart(
        2,
        "0"
      )}`,
      ["end_date"]: `${data?.startDate.getFullYear()}-${String(
        data?.endDate.getMonth() + 1
      ).padStart(2, "0")}-${String(data?.endDate.getDate()).padStart(2, "0")}`,
    }));
  };

  const handleSwitchChange = (matrice_id: Number, matrice_name: string) => {
    setSelectedMatrices((prevSet) => {
      const newSet = new Set(prevSet);
      const Exist = matricesData.find((m) => m?.id === matrice_id)?.toggle;
      if (Exist) {
        newSet.delete(matrice_name); // Remove if already selected
        setfilterData((prev) =>
          data.filter((m) => m?.matrices !== matrice_name)
        );
        setMatricesData(
          matricesData.map((item) =>
            item.id === matrice_id ? { ...item, toggle: false } : item
          )
        );
      } else {
        newSet.add(matrice_name); // Add if not present
        setfilterData(() => data.filter((item) => newSet.has(item?.matrices)));
        setMatricesData(
          matricesData.map((item) =>
            item.id === matrice_id ? { ...item, toggle: true } : item
          )
        );
      }
      return newSet; // Return the updated Set
    });
    localStorage.setItem(
      "AdsOverviewSummaryTableSelectedMatrices",
      JSON.stringify(matricesData)
    );
  };

  const onMonthChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    id: string
  ) => {
    let set = new Set(selectedMonths);
    if (e.target.checked) {
      set.add(id);
      setFilter((prev) => ({
        ...prev,
        month: [...prev.month, Number(id)],
      }));
    } else {
      if (set.has(id)) {
        set.delete(id);
        setFilter((prev) => ({
          ...prev,
          month: prev.month.filter((monthId) => monthId !== Number(id)),
        }));
      }
    }
    setSelectedMonths(set);
  };

  const onWeekChange = (e: React.ChangeEvent<HTMLInputElement>, id: string) => {
    let set = new Set(selectedWeeks);
    if (e.target.checked) {
      set.add(id);
      if (id === "1") {
        setSelweeks((prev) => [...prev, [1, 7]]);
      } else if (id === "2") {
        setSelweeks((prev) => [...prev, [8, 14]]);
      } else if (id === "3") {
        setSelweeks((prev) => [...prev, [15, 21]]);
      } else if (id === "4") {
        setSelweeks((prev) => [...prev, [22, 28]]);
      } else if (id === "5") {
        setSelweeks((prev) => [...prev, [29, 31]]);
      }
    } else {
      if (set.has(id)) {
        set.delete(id);
        if (id === "1") {
          setSelweeks((prev) =>
            prev.filter((range) => !(range[0] === 1 && range[1] === 7))
          );
        } else if (id === "2") {
          setSelweeks((prev) =>
            prev.filter((range) => !(range[0] === 8 && range[1] === 14))
          );
        } else if (id === "3") {
          setSelweeks((prev) =>
            prev.filter((range) => !(range[0] === 15 && range[1] === 21))
          );
        } else if (id === "4") {
          setSelweeks((prev) =>
            prev.filter((range) => !(range[0] === 22 && range[1] === 28))
          );
        } else if (id === "5") {
          setSelweeks((prev) =>
            prev.filter((range) => !(range[0] === 29 && range[1] === 31))
          );
        }
      }
    }
    setSelectedWeeks(set);
  };
  const onDateChange = ({
    target: { value, name },
  }: React.ChangeEvent<HTMLInputElement>): void => {
    if (name === "start") {
      setStartDate(Number(value));
    } else if (name === "end") {
      setEndDate(Number(value));
    }
    if (startDate && endDate) {
      setFilter((prev) => ({
        ...prev,
        week: [[startDate, endDate]],
      }));
    }
  };
  const onTimelineFilterHandler = async () => {
    const token = localStorage.getItem("token");
    const { filter_type, type, start_date, end_date } = filter;
    try {
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      let api = `${BASE_URL}dashboards/adsDashboard/getSummery?brand_id=${brand_id}`;
      const result = await axios.post(
        api,
        { filter_type, type, start_date, end_date },
        { headers }
      );
      const { summary, type: filter_period_type } = result?.data?.data;
      setApiFilterPeriodType(filter_period_type);
      let col: ColDef<DataProps>[] = [
        { field: "matrices", headerName: "Matrices", width: 150,pinned:true },
      ];
      let row: { matrices: string }[] = [];
      let impressionsObj: DynamicObject = {
        id: 1,
        matrices: "Impressions",
      };
      let clicksObj: DynamicObject = {
        id: 2,
        matrices: "Clicks",
      };
      let costsObj: DynamicObject = {
        id: 3,
        matrices: "Spend",
      };
      let salesObj: DynamicObject = {
        id: 4,
        matrices: "Sales",
      };
      let UnitsObj: DynamicObject = {
        id: 5,
        matrices: "Units",
      };
      for (let el of summary) {
        let {
          date,
          year,
          week,
          month,
          impressions,
          clicks,
          cost,
          sales,
          units,
        } = el;
        if (filter_period_type === "DAILY") {
          col.push({
            field: date,
            headerName: `${formatDatefunc({ date })}`,
            width: 150,
          });
          impressionsObj[date] = Number(impressions);
          clicksObj[date] = Number(clicks);
          costsObj[date] = Number(cost);
          salesObj[date] = Number(sales);
          UnitsObj[date] = Number(units);
        } else if (filter_period_type === "WEEKLY") {
          col.push({
            field: week,
            headerName: `${formatWeekInput({ year, month, week })}`,
            width: 150,
          });
          impressionsObj[week] = Number(impressions);
          clicksObj[week] = Number(clicks);
          costsObj[week] = Number(cost);
          salesObj[week] = Number(sales);
          UnitsObj[week] = Number(units);
        } else if (filter_period_type === "MONTHLY") {
          col.push({
            field: month,
            headerName: `${formatMonthYear({ year, month })}`,
            width: 150,
          });
          impressionsObj[month] = Number(impressions);
          clicksObj[month] = Number(clicks);
          costsObj[month] = Number(cost);
          salesObj[month] = Number(sales);
          UnitsObj[month] = Number(units);
        } else if (filter_period_type === "ALL") {
          col.push({ field: "all", headerName: "ALL", width: 150 });
          impressionsObj["all"] = Number(impressions);
          clicksObj["all"] = Number(clicks);
          costsObj["all"] = Number(cost);
          salesObj["all"] = Number(sales);
          UnitsObj["all"] = Number(units);
        }
      }

      setColumnDefs(col);
      let new_arr = [impressionsObj, clicksObj, costsObj, salesObj, UnitsObj];
      setData(new_arr);

      const positionMap = new Map(
        matricesData
          .filter((matrice) => matrice.toggle) // Include only items with toggle = true
          .map((matrice) => [matrice.id, matrice.position]) // Map id to position
      );

      // Filter and sort the data based on positionMap
      const sortedAndFilteredData = new_arr
        .filter((item) => positionMap.has(item.id)) // Include only items with a position
        .sort(
          (a, b) => (positionMap.get(a.id) ?? 0) - (positionMap.get(b.id) ?? 0) // Sort by position
        );
      setfilterData(sortedAndFilteredData);
    } catch (error) {
      appError(error);
    }
  };

  const onSegmentFilterHandler = async () => {
    if (selweeks.length === 0 && startDate && endDate && startDate >= endDate) {
      setErrorToggle(true);
      return;
    }
    const { filter_type, type, year, month } = filter;
    let week = selweeks.length > 0 ? selweeks : [[startDate, endDate]];
    const token = localStorage.getItem("token");
    try {
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      let api = `${BASE_URL}dashboards/adsDashboard/getSummery?brand_id=${brand_id}`;
      const result = await axios.post(
        api,
        { filter_type, type, year, month, week },
        { headers }
      );
      const {
        summary,
        type: filter_period_type,
        filter_type: filter_data_type,
      } = result?.data?.data;
      setApiFilterPeriodType(filter_period_type);
      let col: ColDef<DataProps>[] = [
        { field: "matrices", headerName: "Matrices", width: 150 },
      ];
      let impressionsObj: DynamicObject = {
        id: 1,
        matrices: "Impressions",
      };
      let clicksObj: DynamicObject = {
        id: 2,
        matrices: "Clicks",
      };
      let costsObj: DynamicObject = {
        id: 3,
        matrices: "Spend",
      };
      let salesObj: DynamicObject = {
        id: 4,
        matrices: "Sales",
      };
      let UnitsObj: DynamicObject = {
        id: 5,
        matrices: "Units",
      };
      for (let el of summary) {
        let {
          date,
          year,
          week,
          month,
          impressions,
          clicks,
          cost,
          sales,
          units,
        } = el;
        if (filter_period_type === "DAILY") {
          col.push({
            field: date,
            headerName: `${formatDatefunc({ date })}`,
            width: 150,
          });
          impressionsObj[date] = Number(impressions);
          clicksObj[date] = Number(clicks);
          costsObj[date] = Number(cost);
          salesObj[date] = Number(sales);
          UnitsObj[date] = Number(units);
        } else if (filter_period_type === "WEEKLY") {
          col.push({
            field: week,
            headerName: `${formatWeekInput({ year, month, week })}`,
            width: 150,
          });
          impressionsObj[week] = Number(impressions);
          clicksObj[week] = Number(clicks);
          costsObj[week] = Number(cost);
          salesObj[week] = Number(sales);
          UnitsObj[week] = Number(units);
        } else if (filter_period_type === "MONTHLY") {
          col.push({
            field: month,
            headerName: `${formatMonthYear({ year, month })}`,
            width: 150,
          });
          impressionsObj[month] = Number(impressions);
          clicksObj[month] = Number(clicks);
          costsObj[month] = Number(cost);
          salesObj[month] = Number(sales);
          UnitsObj[month] = Number(units);
        } else if (filter_period_type === "ALL") {
          col.push({ field: "all", headerName: "ALL", width: 150 });
          impressionsObj["all"] = Number(impressions);
          clicksObj["all"] = Number(clicks);
          costsObj["all"] = Number(cost);
          salesObj["all"] = Number(sales);
          UnitsObj["all"] = Number(units);
        }
      }
      setColumnDefs(col);
      let new_arr = [impressionsObj, clicksObj, costsObj, salesObj, UnitsObj];
      setData(new_arr);
      const positionMap = new Map(
        matricesData
          .filter((matrice) => matrice.toggle) // Include only items with toggle = true
          .map((matrice) => [matrice.id, matrice.position]) // Map id to position
      );

      // Filter and sort the data based on positionMap
      const sortedAndFilteredData = new_arr
        .filter((item) => positionMap.has(item.id)) // Include only items with a position
        .sort(
          (a, b) => (positionMap.get(a.id) ?? 0) - (positionMap.get(b.id) ?? 0) // Sort by position
        );
      setfilterData(sortedAndFilteredData);
    } catch (error) {
      appError(error);
    }
  };
  const FilterHandler = () => {
    if (startDate && endDate) {
      setFilter((prev) => ({
        ...prev,
        weeks: [[startDate, endDate]],
      }));
    } else {
      setFilter((prev) => ({
        ...prev,
        weeks: selweeks,
      }));
    }
    if (filter?.filter_type === "TIMELINE") {
      onTimelineFilterHandler();
    } else if (filter?.filter_type === "SEGMENT") {
      onSegmentFilterHandler();
    }
  };
  const [years, setYears] = useState<number[]>(
    getYearsFromRange(range?.min_date, range?.max_date)
  );
  const [draggedItem, setDraggedItem] = useState<Matrice | null>(null);

  const handleDragStart = (item: Matrice) => {
    setDraggedItem(item);
  };

  const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
  };

  const handleDrop = (targetItem: Matrice) => {
    if (!draggedItem || draggedItem.id === targetItem.id) return;

    // for MatricesData
    const draggedIndex = matricesData.findIndex(
      (d) => d?.id === draggedItem.id
    );
    const targetIndex = matricesData.findIndex((d) => d?.id === targetItem.id);
    const updatedMatricesData = [...matricesData];
    let draggedmatriceItem = matricesData.find((d) => d?.id === draggedItem.id);
    let targetmatriceItem = matricesData.find((d) => d?.id === targetItem.id);
    const draggedmatriceIndex = matricesData.findIndex(
      (d) => d?.id === draggedItem.id
    );
    const targetmatriceIndex = matricesData.findIndex(
      (d) => d?.id === targetItem.id
    );
    if (
      draggedmatriceItem &&
      targetmatriceItem &&
      draggedmatriceIndex !== -1 &&
      targetmatriceIndex !== -1
    ) {
      updatedMatricesData[draggedIndex] = {
        ...updatedMatricesData[draggedIndex],
        position: targetIndex,
      };
      updatedMatricesData[targetIndex] = {
        ...updatedMatricesData[targetIndex],
        position: draggedIndex,
      };
      const reorderedMatricesData = updatedMatricesData.sort(
        (a, b) => a.position - b.position
      );
      setMatricesData(reorderedMatricesData);
    }
  };

  useEffect(() => {
    if (brand_id) {
      if (filter?.filter_type === "TIMELINE") {
        onTimelineFilterHandler();
      } else if (filter?.filter_type === "SEGMENT") {
        onSegmentFilterHandler();
      }
    }
    const handleClickOutside = (e: MouseEvent) => {
      if (
        inputRef.current &&
        !inputRef.current.contains(e.target as Node) &&
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target as Node)
      ) {
        setRowsToggle(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [brand_id, filter.filter_type]);

  const CustomTooltipContent: React.FC<CustomTooltipContentProps> = ({
    min_date,
    max_date,
  }) => {
    return (
      <div
        className="p-4 inline-flex flex-col items-start gap-2 rounded-2"
        style={{ backgroundColor: "#3C3C3F" }}
      >
        <div className="flex items-center gap-2 self-stretch">
          <div
            style={{
              color: "var(--Text-Primary-Grey, #97979A)",
              fontFamily: "Inter",
              fontSize: "10px",
              fontStyle: "normal",
              fontWeight: 500,
              lineHeight: "10px",
              letterSpacing: "1.6px",
              textTransform: "uppercase",
            }}
          >
            Data Available From
          </div>
          <div
            style={{
              color: "var(--Text-Primary-White, #FFF)",
              fontFamily: "Inter",
              fontSize: "10px",
              fontStyle: "normal",
              fontWeight: 500,
              lineHeight: "10px",
              letterSpacing: "1.6px",
              textTransform: "uppercase",
            }}
          >
            {formatToDDMMYYYY(min_date)}
          </div>
        </div>
        <div className="flex items-center gap-2 self-stretch">
          <div
            style={{
              color: "var(--Text-Primary-Grey, #97979A)",
              fontFamily: "Inter",
              fontSize: "10px",
              fontStyle: "normal",
              fontWeight: 500,
              lineHeight: "10px",
              letterSpacing: "1.6px",
              textTransform: "uppercase",
            }}
          >
            Data Available Till
          </div>
          <div
            style={{
              color: "var(--Text-Primary-White, #FFF)",
              fontFamily: "Inter",
              fontSize: "10px",
              fontStyle: "normal",
              fontWeight: 500,
              lineHeight: "10px",
              letterSpacing: "1.6px",
              textTransform: "uppercase",
            }}
          >
            {formatToDDMMYYYY(max_date)}
          </div>
        </div>
      </div>
    );
  };

  const errorCloseHandler = () => {
    setErrorToggle(false);
  };

  const onClearHandler = () => {
    if(filter?.filter_type === "TIMELINE"){
    setFilter({
      filter_type: "TIMELINE",
      type: "DAILY",
      month: [new Date().getMonth() + 1],
      year: [2024],
      week: [[1, 7]],
      start_date: getDateMinusDays(7),
      end_date: formatDate(new Date()),
    });
  }
  else if(filter?.filter_type === "SEGMENT"){
    setSelectedWeeks(
      new Set(["1"])
    );
    setSelectedMonths(
      new Set([String(new Date().getMonth() + 1 )])
    );
    setFilter({
      filter_type: "SEGMENT",
      type: "DAILY",
      month: [new Date().getMonth() + 1],
      year: [2024],
      week: [[1, 7]],
      start_date: getDateMinusDays(7),
      end_date: formatDate(new Date()),
    });
  }
  }

  useEffect(() => {
    const positionMap = new Map(
      matricesData
        .filter((matrice) => matrice.toggle) // Include only items with toggle = true
        .map((matrice) => [matrice.id, matrice.position]) // Map id to position
    );
    // Filter and sort the data based on positionMap
    const sortedAndFilteredData = data
      .filter((item) => positionMap.has(item.id)) // Include only items with a position
      .sort(
        (a, b) => (positionMap.get(a.id) ?? 0) - (positionMap.get(b.id) ?? 0) // Sort by position
      );

    setfilterData(sortedAndFilteredData);
    localStorage.setItem(
      "AdsOverviewSummaryTableSelectedMatrices",
      JSON.stringify(matricesData)
    );
  }, [matricesData]);

  return (
    <div className="flex ">
      <div
        className="p-6 flex w-[23%] flex-col justify-between items-start flex-shrink-0"
        style={{
          borderRight: `1px solid #EAEAED`,
          height: "calc(100vh - 72px - 52px)",
          backgroundColor: WHITE.W_100,
          boxShadow: `0px 4px 16px 6px rgba(130,130,130,0.05)`,
          overflowY: "auto",
          scrollbarColor: "red",
        }}
      >
        <div
          className="flex flex-col items-start gap-6 self-stretch"
          // style={{overflowY:"scroll", height: "calc(100vh - 72px - 52px)",}}
        >
          {/* IMG */}
          <div
            className="flex w-full p-4 justify-center items-center gap-3"
            style={{ backgroundColor: "#F2F2F5" }}
          >
            <img
              src="/asian.png"
              className="h-[28px] flex-shrink-0"
              alt="Asian"
            />
            <div className="flex flex-col justify-center items-center gap-1 flex-grow flex-shrink-0 basis-0">
              <div
                className="self-stretch"
                style={{
                  fontSize: "14px",
                  fontWeight: "500",
                  lineHeight: "18px",
                  color: "#1C1C1E",
                }}
              >
                Asian Footwear
              </div>
              <div
                className="self-stretch"
                style={{
                  fontSize: "10px",
                  fontWeight: "500",
                  lineHeight: "10px",
                  color: "#97979A",
                  letterSpacing: "1.6px",
                }}
              >
                Amazon
              </div>
            </div>
          </div>

          <div className="flex flex-col items-start gap-[32px] self-stretch">
            {/* PERIOD */}
            <div className="flex flex-col items-start gap-2 self-stretch">
              <div
                className="self-stretch"
                style={{
                  fontSize: "14px",
                  fontWeight: "500",
                  lineHeight: "18px",
                  color: "#1C1C1E",
                }}
              >
                Period
              </div>
              <div className="flex flex-col items-start gap-3 self-stretch">
                <div className="flex items-center gap-3 self-stretch">
                  <div
                    className="flex h-[38px] w-[50%] px-4 py-2 justify-center items-center gap-1 rounded-[4px] "
                    style={{
                      backgroundColor:
                        filter?.type === "DAILY" ? "#1565C0" : "#FFF",
                    }}
                    onClick={() =>
                      setFilter((prev) => ({ ...prev, ["type"]: "DAILY" }))
                    }
                  >
                    <div
                      className="self-stretch"
                      style={{
                        fontSize: "12px",
                        fontWeight: "700",
                        lineHeight: "18px",
                        color: filter?.type === "DAILY" ? "#FFF" : "#B7B7B9",
                      }}
                    >
                      Daily
                    </div>
                  </div>
                  <div
                    className="flex h-[38px] w-[50%] px-4 py-2 justify-center items-center gap-1 rounded-[4px] "
                    style={{
                      backgroundColor:
                        filter?.type === "WEEKLY" ? "#1565C0" : "#FFF",
                    }}
                    onClick={() =>
                      setFilter((prev) => ({ ...prev, ["type"]: "WEEKLY" }))
                    }
                  >
                    <div
                      className="self-stretch"
                      style={{
                        fontSize: "12px",
                        fontWeight: "700",
                        lineHeight: "18px",
                        color: filter?.type === "WEEKLY" ? "#FFF" : "#B7B7B9",
                      }}
                    >
                      Weekly
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-3 self-stretch">
                  <div
                    className="flex h-[38px] w-[50%] px-4 py-2 justify-center items-center gap-1 rounded-[4px] "
                    style={{
                      backgroundColor:
                        filter?.type === "MONTHLY" ? "#1565C0" : "#FFF",
                    }}
                    onClick={() =>
                      setFilter((prev) => ({ ...prev, ["type"]: "MONTHLY" }))
                    }
                  >
                    <div
                      className="self-stretch"
                      style={{
                        fontSize: "12px",
                        fontWeight: "700",
                        lineHeight: "18px",
                        color: filter?.type === "MONTHLY" ? "#FFF" : "#B7B7B9",
                      }}
                    >
                      Monthly
                    </div>
                  </div>
                  <div
                    className="flex h-[38px] w-[50%] px-4 py-2 justify-center items-center gap-1 rounded-[4px] "
                    style={{
                      backgroundColor:
                        filter?.type === "ALL" ? "#1565C0" : "#FFF",
                    }}
                    onClick={() =>
                      setFilter((prev) => ({ ...prev, ["type"]: "ALL" }))
                    }
                  >
                    <div
                      className="self-stretch"
                      style={{
                        fontSize: "12px",
                        fontWeight: "700",
                        lineHeight: "18px",
                        color: filter?.type === "ALL" ? "#FFF" : "#B7B7B9",
                      }}
                    >
                      All
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="w-full"
              style={{ border: `1px solid #EAEAED` }}
            ></div>

            <div className="flex flex-col items-start gap-6 self-stretch">
              <div className="flex items-center gap-3 self-stretch">
                <div
                  className="flex h-[38px] w-[50%] px-4 py-2 justify-center items-center gap-1 rounded-[4px] "
                  style={{
                    backgroundColor:
                      filter?.filter_type === "TIMELINE" ? "#1565C0" : "#FFF",
                  }}
                  onClick={() =>
                    setFilter((prev) => ({
                      ...prev,
                      ["filter_type"]: "TIMELINE",
                    }))
                  }
                >
                  <div
                    className="self-stretch"
                    style={{
                      fontSize: "12px",
                      fontWeight: "700",
                      lineHeight: "18px",
                      color:
                        filter?.filter_type === "TIMELINE" ? "#FFF" : "#B7B7B9",
                    }}
                  >
                    Timeline
                  </div>
                </div>
                <div
                  className="flex h-[38px] w-[50%] px-4 py-2 justify-center items-center gap-1 rounded-[4px] "
                  style={{
                    backgroundColor:
                      filter?.filter_type === "SEGMENT" ? "#1565C0" : "#FFF",
                  }}
                  onClick={() => {
                    setFilter((prev) => ({
                      ...prev,
                      ["filter_type"]: "SEGMENT",
                    }));
                    setSelweeks([[1, 7]]);
                    setSelectedWeeks(new Set(["1"]));
                  }}
                >
                  <div
                    className="self-stretch"
                    style={{
                      fontSize: "12px",
                      fontWeight: "700",
                      lineHeight: "18px",
                      color:
                        filter?.filter_type === "SEGMENT" ? "#FFF" : "#B7B7B9",
                    }}
                  >
                    Segment
                  </div>
                </div>
              </div>

              {filter?.filter_type === "TIMELINE" && (
                <div
                  className="flex flex-col items-start gap-2 self-stretch"
                  style={{ position: "relative" }}
                >
                  <div
                    className="self-stretch"
                    style={{
                      fontSize: "14px",
                      fontWeight: "500",
                      lineHeight: "18px",
                      color: "#1C1C1E",
                    }}
                  >
                    Date Range
                  </div>
                  <div
                    className="flex items-start self-stretch rounded-[8px]"
                    style={{ border: `1px solid #EAEAED` }}
                  >
                    <div className="w-full flex h-[44px] px-4 py-2 justify-between items-center gap-2 ">
                      {`${String(filter?.start_date.split("-").pop()).padStart(
                        2,
                        "0"
                      )}/${String(
                        filter?.start_date.split("-")[
                          filter?.start_date.split("-").length - 2
                        ]
                      ).padStart(2, "0")}/${String(
                        filter?.start_date.split("-")[
                          filter?.start_date.split("-").length - 3
                        ]
                      ).padStart(2, "0")} - ${String(
                        filter?.end_date.split("-").pop()
                      ).padStart(2, "0")}/${String(
                        filter?.end_date.split("-")[
                          filter?.end_date.split("-").length - 2
                        ]
                      ).padStart(2, "0")}/${String(
                        filter?.end_date.split("-")[
                          filter?.end_date.split("-").length - 3
                        ]
                      ).padStart(2, "0")}`}
                      <img
                        src={DateIcon}
                        alt="My SVG Icon"
                        style={{ cursor: "pointer" }}
                        onClick={() => setdatename("BASE")}
                      />
                    </div>
                  </div>
                  {datename === "BASE" && (
                    <div
                      className=""
                      style={{
                        position: "absolute",
                        top: 73,
                        zIndex: 100,
                        right: 0,
                      }}
                    >
                      <DateRangeComponent
                        startDate={new Date(filter?.start_date)}
                        endDate={new Date(filter?.end_date)}
                        apply={apply}
                        setdatename={setdatename}
                        maxDate={range?.max_date}
                        minDate={range?.min_date}
                      />
                    </div>
                  )}
                </div>
              )}

              {filter?.filter_type === "SEGMENT" && (
                <div className="flex flex-col items-start gap-6 self-stretch w-full pb-6">
                  <div className="flex flex-col items-start gap-2 self-stretch">
                    <div
                      style={{
                        fontSize: "14px",
                        fontWeight: "500",
                        lineHeight: "18px",
                        color: "#1C1C1E",
                      }}
                    >
                      Year
                    </div>
                    <div className="flex justify-start flex-wrap items-center gap-3 self-stretch">
                      {years &&
                        years.length > 0 &&
                        years.map((year) => (
                          <div
                            className="flex p-2 justify-center items-center gap-2 rounded-[4px] "
                            style={{
                              backgroundColor: filter?.year.includes(year)
                                ? "#E3F2FD"
                                : "#F2F2F5",
                            }}
                            onClick={() => {
                              if (filter?.year.includes(year)) {
                                setFilter((prev) => ({
                                  ...prev,
                                  year: prev.year.filter((y) => y !== year),
                                }));
                              } else {
                                setFilter((prev) => ({
                                  ...prev,
                                  year: [...prev.year, year],
                                }));
                              }
                            }}
                          >
                            <div
                              style={{
                                width: "46px",
                                color: "#97979A",
                                textAlign: "center",
                                fontSize: "10px",
                                fontWeight: "500",
                                lineHeight: "10px",
                                letterSpacing: "1.6px",
                                textTransform: "uppercase",
                              }}
                            >
                              {year}
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>

                  <div className="flex flex-col items-start gap-2 self-stretch w-full relative">
                    <div
                      style={{
                        fontSize: "14px",
                        fontWeight: "500",
                        lineHeight: "18px",
                        color: "#1C1C1E",
                      }}
                    >
                      Month
                    </div>
                    <MultiSelect
                      children={months}
                      selected={selectedMonths}
                      onChange={onMonthChange}
                      placeholder="Select Months"
                    />
                  </div>

                  <div className="flex flex-col items-start gap-2 self-stretch w-full relative">
                    <div
                      style={{
                        fontSize: "14px",
                        fontWeight: "500",
                        lineHeight: "18px",
                        color: "#1C1C1E",
                      }}
                    >
                      Week
                    </div>
                    <MultiSelect
                      children={weeks}
                      selected={selectedWeeks}
                      onChange={onWeekChange}
                      placeholder="Select Weeks"
                      disabled={startDate || endDate ? true : false}
                    />
                  </div>

                  <div className="w-full flex items-center gap-2 self-stretch">
                    <div
                      className="w-[50%]"
                      style={{ border: `1px solid #EAEAED` }}
                    ></div>
                    <div className="" style={{ color: "#97979A" }}>
                      OR
                    </div>
                    <div
                      className="w-[50%]"
                      style={{ border: `1px solid #EAEAED` }}
                    ></div>
                  </div>

                  <div className="w-full flex items-start gap-4 self-stretch">
                    <div className="flex flex-col items-start gap-2 w-[47.5%]">
                      <div
                        style={{
                          fontSize: "14px",
                          fontWeight: "500",
                          lineHeight: "18px",
                          color: "#1C1C1E",
                        }}
                      >
                        From
                      </div>
                      <Input
                        placeholder="Enter Date"
                        sx={{
                          "--Input-focusedThickness": "0px",
                          width: "100%",
                          height: "44px",
                          paddingX: "16px",
                          paddingY: "8px",
                          backgroundColor: "#FFF",
                          "&.Mui-disabled": {
                            backgroundColor: "#F3F3F7",
                          },
                        }}
                        name="start"
                        onChange={onDateChange}
                        disabled={selweeks.length > 0 && true}
                      />
                    </div>

                    <div className="flex flex-col items-start gap-2 w-[47.5%]">
                      <div
                        style={{
                          fontSize: "14px",
                          fontWeight: "500",
                          lineHeight: "18px",
                          color: "#1C1C1E",
                        }}
                      >
                        To
                      </div>
                      <Input
                        placeholder="Enter Date"
                        sx={{
                          "--Input-focusedThickness": "0px",
                          width: "100%",
                          height: "44px",
                          paddingX: "16px",
                          paddingY: "8px",
                          backgroundColor: "#FFF",
                          "&.Mui-disabled": {
                            backgroundColor: "#F3F3F7",
                          },
                        }}
                        name="end"
                        onChange={onDateChange}
                        disabled={selweeks.length > 0 && true}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="flex items-center gap-3 self-stretch">
          <Button
            color="neutral"
            sx={{
              height: 40,
              // width: 150,
              width: "100%",
              fontSize: 14,
              fontWeight: 700,
              backgroundColor: "#FFF",
              lineHeight: "20px",
              color: "#1C1C1E",
              ":hover": {
                backgroundColor: BLACK.B_20,
              },
              borderRadius: "6px",
              border: `1px solid #EAEAED`,
            }}
            onClick={onClearHandler}
          >
            Clear Filter
          </Button>
          <Button
            // loading={lodingOnSave}
            sx={{
              height: 40,
              // width: 150,
              width: "100%",
              fontSize: 14,
              fontWeight: 700,
              backgroundColor: "#1565C0",
              lineHeight: "18px",
              color: "#FFF",
              borderRadius: 6,
            }}
            onClick={FilterHandler}
          >
            Apply Filter
          </Button>
          <Snackbar
            open={errorToggle}
            autoHideDuration={3000}
            onClose={errorCloseHandler}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            sx={{
              display: "flex",
              width: "500px",
              paddingTop: "16px",
              paddingBottom: "16px",
              paddingLeft: "22px",
              paddingRight: "16px",
              alignItems: "start",
              gap: "24px",
              borderRadius: "8px",
              backgroundColor: "#FFF",
              borderLeft: "6px solid #D10C00",
              boxShadow: "0px 4px 24px 6px rgba(79, 79, 79, 0.10)",
            }}
          >
            <div className="flex items-start gap-4 ">
              <img src={ErrorIcon} alt="Error Icon" />
              <div className="flex w-[370px] flex-col items-start gap-1">
                <div
                  style={{
                    color: "var(--Text-Primary-Black, #1C1C1E)",
                    fontFamily: "Inter",
                    fontSize: "14px",
                    fontStyle: "normal",
                    fontWeight: 700,
                    lineHeight: "18px",
                  }}
                >
                  Invalid Input
                </div>
                <div
                  style={{
                    color: "var(--Text-Primary-Grey, #97979A)",
                    fontFamily: "Inter",
                    fontSize: "12px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "18px",
                  }}
                >
                  {" "}
                  The start date must be before the end date.
                </div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                width: "20px",
                height: "20px",
                padding: "4.167px",
                justifyContent: "center",
                alignItems: "center",
                flexShrink: 0,
                cursor: "pointer",
              }}
            >
              <img
                src={ErrorCrossIcon}
                alt="Error Cross Icon"
                style={{
                  height: "100%",
                  width: "100%",
                }}
                onClick={errorCloseHandler}
              />
            </div>
          </Snackbar>
        </div>
      </div>
      <div className="flex flex-col items-start gap-6 p-10 w-full">
        <div className="flex p-1 w-full justify-between items-center self-stretch">
          <div className="flex flex-col justify-center items-start gap-2">
            <div
              className=""
              style={{
                color: "#1C1C1E",
                fontSize: "32px",
                fontWeight: "700",
                lineHeight: "42px",
              }}
            >
              Good Morning, {full_name ? `${words[0]}` : ""}
            </div>
            <div className="flex justify-end items-center gap-2 rounded-[4px]">
              <div
                style={{
                  fontSize: "10px",
                  fontWeight: "500",
                  lineHeight: "10px",
                  letterSpacing: "1.6px",
                  textTransform: "uppercase",
                  color: "#97979A",
                }}
              >
                Last UPDATED ON {formatToDDMMYYYY(range?.max_date)}
              </div>

              <Tooltip
                title={
                  <CustomTooltipContent
                    min_date={range?.min_date}
                    max_date={range?.max_date}
                  />
                }
                placement="right"
                sx={{
                  bgcolor: "#3C3C3F",
                  padding: "16px",
                  display: "inline-flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "8px",
                  borderRadius: "8px",
                  fontSize: "12px",
                  fontWeight: "500",
                  fontStyle: "normal",
                  lineHeight: "18px",
                  color: WHITE.W_100,
                }}
              >
                <img src={Icon} alt="My SVG Icon" />
              </Tooltip>
            </div>
          </div>
          <div
            className="flex h-[42px] w-[240px] p-1 items-center"
            style={{ borderRadius: "4px", backgroundColor: "#F2F2F5" }}
          >
            <div
              className="flex w-[120px] px-4 py-2 justify-center items-center gap-2 rounded-[4px] cursor-pointer"
              style={{
                backgroundColor:
                  location.pathname === "/Adsdashboard/overview/comparison"
                    ? "#1565C0"
                    : "#F2F2F5",
              }}
              onClick={() => navigate("/Adsdashboard/overview/comparison")}
            >
              <div
                style={{
                  fontSize: "12px",
                  fontWeight: "500",
                  lineHeight: "18px",
                  color:
                    location.pathname === "/Adsdashboard/overview/comparison"
                      ? "#FFF"
                      : "#B7B7B9",
                }}
              >
                Comparison
              </div>
            </div>
            <div
              className="flex w-[120px] px-4 py-2 justify-center items-center gap-2 rounded-[4px] cursor-pointer"
              style={{
                backgroundColor:
                  location.pathname === "/Adsdashboard/overview/summary"
                    ? "#1565C0"
                    : "#F2F2F5",
              }}
            >
              <div
                style={{
                  fontSize: "12px",
                  fontWeight: "500",
                  lineHeight: "18px",
                  color:
                    location.pathname === "/Adsdashboard/overview/summary"
                      ? "#FFF"
                      : "#B7B7B9",
                }}
              >
                Summary
              </div>
            </div>
          </div>
        </div>

        <div
          className="flex flex-col items-start self-stretch w-full rounded-[8px]"
          style={{
            boxShadow: `0px 4px 16px 6px rgba(130,130,130,0.05)`,
            maxHeight: "calc(100vh - 72px - 230px)",
            // overflowY:"scroll"
          }}
        >
          <div
            className="flex p-6 justify-between items-end gap-4 self-stretch w-full"
            style={{
              borderTopLeftRadius: "8px",
              borderTopRightRadius: "8px",
            }}
          >
            <div className="flex flex-col justify-center items-start gap-1 ">
              <div
                className="self-stdetch"
                style={{
                  fontSize: "20px",
                  fontWeight: "700",
                  lineHeight: "26px",
                  color: "#1C1C1E",
                }}
              >
                {apiFilterPeriodtype === "DAILY"
                  ? "Daily"
                  : apiFilterPeriodtype === "MONTHLY"
                  ? "Monthly"
                  : apiFilterPeriodtype === "WEEKLY"
                  ? "Weekly"
                  : "All"}{" "}
                Performance Metrics
              </div>
              <div
                className="self-stretch"
                style={{
                  fontSize: "14px",
                  fontWeight: "400",
                  lineHeight: "18px",
                  color: "#97979A",
                }}
              >
                Review the{" "}
                {apiFilterPeriodtype === "DAILY"
                  ? "daily"
                  : apiFilterPeriodtype === "MONTHLY"
                  ? "monthly"
                  : apiFilterPeriodtype === "WEEKLY"
                  ? "weekly"
                  : "all"}{" "}
                performance and metrics in detail.
              </div>
            </div>
            <div ref={inputRef} className="" style={{ position: "relative" }}>
              <Button
                color="neutral"
                sx={{
                  height: 40,
                  width: 140,
                  fontSize: 14,
                  fontWeight: 700,
                  backgroundColor: "#FFF",
                  lineHeight: "20px",
                  color: "#1C1C1E",
                  ":hover": {
                    backgroundColor: "#1565C0",
                    color: "#FFF",
                  },

                  paddingX: "6px",
                  paddingY: 0,
                  gap: "8px",
                  borderRadius: "6px",
                  border: `1px solid #EAEAED`,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onClick={() => {
                  setRowsToggle(!rowsToggle);
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M4.42308 9.01434C4.00211 9.01434 3.64579 8.8685 3.35413 8.57684C3.06246 8.28517 2.91663 7.92885 2.91663 7.50788V4.42308C2.91663 4.00211 3.06246 3.64579 3.35413 3.35413C3.64579 3.06246 4.00211 2.91663 4.42308 2.91663H15.5768C15.9978 2.91663 16.3541 3.06246 16.6458 3.35413C16.9375 3.64579 17.0833 4.00211 17.0833 4.42308V7.50788C17.0833 7.92885 16.9375 8.28517 16.6458 8.57684C16.3541 8.8685 15.9978 9.01434 15.5768 9.01434H4.42308ZM4.42308 7.76434H15.5768C15.6517 7.76434 15.7132 7.74031 15.7612 7.69225C15.8093 7.6442 15.8333 7.58274 15.8333 7.50788V4.42308C15.8333 4.34822 15.8093 4.28677 15.7612 4.23871C15.7132 4.19065 15.6517 4.16663 15.5768 4.16663H4.42308C4.34822 4.16663 4.28677 4.19065 4.23871 4.23871C4.19065 4.28677 4.16663 4.34822 4.16663 4.42308V7.50788C4.16663 7.58274 4.19065 7.6442 4.23871 7.69225C4.28677 7.74031 4.34822 7.76434 4.42308 7.76434ZM4.42308 17.0833C4.00211 17.0833 3.64579 16.9375 3.35413 16.6458C3.06246 16.3541 2.91663 15.9978 2.91663 15.5768V12.5C2.91663 12.079 3.06246 11.7227 3.35413 11.431C3.64579 11.1393 4.00211 10.9935 4.42308 10.9935H15.5768C15.9978 10.9935 16.3541 11.1393 16.6458 11.431C16.9375 11.7227 17.0833 12.079 17.0833 12.5V15.5768C17.0833 15.9978 16.9375 16.3541 16.6458 16.6458C16.3541 16.9375 15.9978 17.0833 15.5768 17.0833H4.42308ZM4.42308 15.8333H15.5768C15.6517 15.8333 15.7132 15.8093 15.7612 15.7612C15.8093 15.7132 15.8333 15.6517 15.8333 15.5768V12.5C15.8333 12.4251 15.8093 12.3636 15.7612 12.3156C15.7132 12.2675 15.6517 12.2435 15.5768 12.2435H4.42308C4.34822 12.2435 4.28677 12.2675 4.23871 12.3156C4.19065 12.3636 4.16663 12.4251 4.16663 12.5V15.5768C4.16663 15.6517 4.19065 15.7132 4.23871 15.7612C4.28677 15.8093 4.34822 15.8333 4.42308 15.8333Z"
                    fill="#1C1C1E"
                  />
                </svg>
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: "700",
                    textAlign: "center",
                    lineHeight: "18px",
                    color: "#1C1C1E",
                  }}
                >
                  Rows
                </div>
              </Button>
              {rowsToggle && (
                <div
                  ref={dropdownRef}
                  className="custom-scrollbar flex w-[227px] h-[180px] p-4 flex-col items-start gap-[23px] rounded-[8px] "
                  style={{
                    position: "absolute",
                    top: 45,
                    right: 0,
                    backgroundColor: "white",
                    boxShadow: "0px 4px 10px 4px rgba(28, 28, 30, 0.05)",
                    zIndex: 10,
                    overflowY: "scroll",
                  }}
                >
                  <style>
                    {`
      .custom-scrollbar::-webkit-scrollbar {
        width: 6px;
        height: 50px;
        
      }

      .custom-scrollbar::-webkit-scrollbar-track {
        background: white;
      }

      .custom-scrollbar::-webkit-scrollbar-thumb {
        background: #F2F2F5;
        border-radius: 8px;
      }

    `}
                  </style>
                  {matricesData.length > 0 &&
                    matricesData.map((m: Matrice) => (
                      <div
                        className="flex items-center justify-between gap-2 self-stretch"
                        key={m?.matrice}
                        draggable
                        onDragStart={() => handleDragStart(m)}
                        onDragOver={handleDragOver}
                        onDrop={() => handleDrop(m)}
                      >
                        <div className="flex items-center gap-1">
                          <img
                            src={DragAndDropIcon}
                            alt="Drag And Drop Icon"
                            style={{ cursor: "pointer" }}
                          />
                          <div
                            className=""
                            style={{
                              paddingLeft: "5px",
                              color: "#1C1C1E",
                              fontSize: "14px",
                              fontWeight: "400",
                              lineHeight: "18px",
                            }}
                          >
                            {m?.matrice}
                          </div>
                        </div>
                        <Switch
                          checked={m?.toggle}
                          onChange={(event) =>
                            handleSwitchChange(m?.id, m?.matrice)
                          }
                        />
                      </div>
                    ))}
                </div>
              )}
            </div>
          </div>

          <div
            className={"ag-theme-quartz"}
            style={{ width: "100%", height: "808px", overflowY: "hidden" }}
          >
            {columnDefs.length > 0 && (
              <AgGridReact
                rowData={filterdata}
                columnDefs={columnDefs}
                //defaultColDef={defaultColDef}
                // getRowId={()=> }
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Summary;
